// extracted by mini-css-extract-plugin
export var content = "TextSection-module--content--c5b90";
export var wrapper = "TextSection-module--wrapper--ac751";